// main.js
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import VueI18n from 'vue-i18n';
import en from './locales/en.json';
import id from './locales/id.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import zh from './locales/zh.json';
import th from './locales/th.json';
import vn from './locales/vn.json';
Vue.use(VueI18n);
/***
 * 根据用户语言设置语言
 * 默认为 en
 * 路由守卫会查询url是否有language参数，如果有则优先使用url的language参数
 **/
const messages = { en, id, es, pt, zh, th, vn };
const userLang = navigator.language || navigator.userLanguage;

const defaultLang = 'en';
const langMap = {
  en: 'en',
  id: 'id',
  pt: 'pt',
  es: 'es',
  zh: 'zh',
  th: 'th',
  vi: 'vn',
  vn: 'vn',
};

export function normalizeLocale(value, fallback = null) {
  const candidate = Array.isArray(value) ? value[0] : value;
  if (typeof candidate !== 'string' || !candidate.trim()) return fallback;

  const normalized = candidate.trim().toLowerCase().replace(/_/g, '-');
  return langMap[normalized] || langMap[normalized.split('-')[0]] || fallback;
}

const locale = normalizeLocale(userLang, defaultLang);

const i18n = new VueI18n({
  locale,
  messages,
});


Vue.config.productionTip = false;
Vue.use(ElementUI);

// --- 全局错误处理 ---
Vue.config.errorHandler = function (err, vm, info) {
  // Do not log the Vue instance because it may contain session or image data.
  console.error("Global Vue error:", {
    name: err && err.name ? err.name : 'Error',
    code: err && err.code ? err.code : 'UNEXPECTED_ERROR',
    info,
    route: router.currentRoute.path,
  });

  // 避免在首页本身出错时无限重定向
  if (router.currentRoute.path !== '/') {
    // 提示用户并重定向到首页
    if (vm && vm.$message) {
      vm.$message.error(i18n.t('technical.unexpectedError'));
    } else {
      // 降级提示
      alert(i18n.t('technical.unexpectedError'));
    }
    const safeQuery = Object.keys(router.currentRoute.query || {}).reduce(
      (query, key) => {
        if (key !== 'errorMessage') query[key] = router.currentRoute.query[key];
        return query;
      },
      {}
    );
    router.replace({ path: '/', query: safeQuery });
  }
};
// --- 全局错误处理结束 ---

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
export { i18n }; // 导出 i18n 实例
